module.exports = __webpack_public_path__ + "static/media/meetup0503.1e35d496.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/meetup0503.jpg
// module id = 1601
// module chunks = 0